import { useAuth0 } from "@auth0/auth0-react";
import { Navigate } from "react-router-dom";
import { isAdmin } from "../features/user/utils";
import React from "react";

export default function Login(){
    const { user } = useAuth0();

    return (user && isAdmin(user)) ? <Navigate to="admin" /> : <Navigate to="vetrina" />;
}